import {
  Checkbox as MUICheckbox,
  CheckboxProps as MUICheckboxProps,
  FormControlLabel,
  FormControlLabelProps,
  useTheme,
} from '@mui/material';
import { CheckboxIcon } from '../../assets/icons/checkbox.tsx';
import { CheckboxCheckedIcon } from '../../assets/icons/checkbox-checked.tsx';
import { checkboxSx, formControlSx, getCheckboxTypographySx } from './styles.ts';

export type CheckboxProps = {
  label?: string
  formControlLabelProps?: Omit<FormControlLabelProps, 'label' | 'control'>
} & MUICheckboxProps

export const Checkbox = (props: CheckboxProps) => {
  const { checked, onChange, label, formControlLabelProps, ...rest } = props;
  const theme = useTheme();
  return (
    <FormControlLabel
      checked={checked}
      control={
        <MUICheckbox
          onChange={onChange}
          icon={<CheckboxIcon />}
          checkedIcon={<CheckboxCheckedIcon />}
          sx={checkboxSx}
          {...rest}
        />
      }
      label={label}
      slotProps={{
        typography: {
          sx: getCheckboxTypographySx(theme),
        },
      }}
      sx={formControlSx}
      {...formControlLabelProps}
    />
  );
};
